import React from 'react';

export const NotificationIcon = props =>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="12"
    height="16"
    viewBox="0 0 12 16"
    style={{
      fillRule: 'evenodd',
    }}
    {...props}
  >
    <path
      d="M845,225H835a0.858,0.858,0,0,1-1-1v-1a1.07,1.07,0,0,1,1-1v-4a5.207,5.207,0,0,1,4-5,1.023,1.023,0,0,1,1-1.007A1.013,1.013,0,0,1,841,213a5.205,5.205,0,0,1,4,5v4a1.044,1.044,0,0,1,1,1v1A0.89,0.89,0,0,1,845,225Zm-5,3a2.02,2.02,0,0,1-2-2h4A2.02,2.02,0,0,1,840,228Z"
      transform="translate(-834 -212)"
    />
  </svg>;



// WEBPACK FOOTER //
// ./app/components/icons/notification-icon.js